export const STATUS_DRAFT = 1
export const STATUS_IN_PROGRESS = 2
export const STATUS_FINISHED = 3
export const STATUS_FAILED = 4
export const STATUS_QUEUED = 5
export const STATUS_STOPPED = 6

